module.exports = __webpack_public_path__ + "static/polaris-a30dd7ca37f65a416af40ca652ef011e.gif";